// Axion Elite — Micro-interactions: custom cursor + card tilt
// Desktop-precise-pointer + motion-OK only. On touch devices or under
// prefers-reduced-motion, this entire file no-ops (no listeners attached
// at all, not just visually suppressed).

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  if (reduced || !fine) return;

  function initCursor() {
    var dot = document.createElement('div');
    dot.className = 'axion-cursor-dot';
    dot.setAttribute('aria-hidden', 'true');

    var ring = document.createElement('div');
    ring.className = 'axion-cursor-ring';
    ring.setAttribute('aria-hidden', 'true');

    document.body.appendChild(dot);
    document.body.appendChild(ring);
    document.body.classList.add('has-custom-cursor');

    var mouseX = 0;
    var mouseY = 0;
    var ringX = 0;
    var ringY = 0;
    var raf = null;

    function updateRing() {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = 'translate(' + ringX + 'px,' + ringY + 'px)';
      raf = requestAnimationFrame(updateRing);
    }

    function onMove(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.transform = 'translate(' + mouseX + 'px,' + mouseY + 'px)';
      if (!raf) raf = requestAnimationFrame(updateRing);
    }

    document.addEventListener('pointermove', onMove, { passive: true });

    var interactive = document.querySelectorAll('a, button, .axion-tilt');
    interactive.forEach(function (el) {
      el.addEventListener('pointerenter', function () { ring.classList.add('is-active'); });
      el.addEventListener('pointerleave', function () { ring.classList.remove('is-active'); });
    });
  }

  function initTilt() {
    var cards = document.querySelectorAll('.axion-tilt');
    if (!cards.length) return;

    var MAX_DEG = 6;

    cards.forEach(function (card) {
      var raf = null;
      var pendingX = 0;
      var pendingY = 0;

      function apply() {
        card.style.transform =
          'perspective(800px) rotateX(' + pendingX + 'deg) rotateY(' + pendingY + 'deg) scale(1.02)';
        raf = null;
      }

      card.addEventListener('pointermove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        pendingY = (px - 0.5) * MAX_DEG * 2;
        pendingX = (0.5 - py) * MAX_DEG * 2;
        if (!raf) raf = requestAnimationFrame(apply);
      });

      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  function init() {
    initCursor();
    initTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
